import { ApiService } from '@services/ApiService'
import { message } from 'antd'
import { observer } from 'mobx-react'
import { lazy, Suspense, useEffect, useState } from 'react'

import { openedEmail } from './citationNavigation'

// Loaded the first time an email is opened: the panel does not carry the app's form components.
const EmailTrackingDetailModal = lazy(
  () => import('@components/EmailTracking/EmailTrackingDetailModal')
)

/*
 * The email an answer names, opened in place: the same detail modal the case screen and the
 * email tracking list open. The answer only says which tracking row (the server's citation id);
 * the row itself is read again, so what is shown is the email as it is now.
 */
const EmailCitationModal = () => {
  const trackingId = openedEmail.trackingId
  const [emailTracking, setEmailTracking] = useState<any>(null)

  useEffect(() => {
    if (!trackingId) {
      setEmailTracking(null)
      return
    }

    let current = true
    ApiService.EmailTracking.GetById(trackingId, { disableCache: true })
      .then(res => {
        if (!current) {
          return
        }
        if (res?.data) {
          setEmailTracking(res.data)
        } else {
          message.warning('This email could not be found.')
          openedEmail.close()
        }
      })
      .catch(() => {
        if (current) {
          message.error('This email could not be opened.')
          openedEmail.close()
        }
      })

    return () => {
      current = false
    }
  }, [trackingId])

  if (!trackingId || !emailTracking) {
    return null
  }

  return (
    <Suspense fallback={null}>
      <EmailTrackingDetailModal
        emailTracking={emailTracking}
        onCancel={() => openedEmail.close()}
      />
    </Suspense>
  )
}

export default observer(EmailCitationModal)
